var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    {
      staticClass: "shadow-lg vs-con-loading__container",
      attrs: { title: _vm.capitalize(_vm.$t("attribute.payment")) }
    },
    [
      _c(
        "div",
        { attrs: { id: "payment-box" } },
        [
          _vm.paymentErrors.length > 0
            ? _vm._l(_vm.paymentErrors, function(error) {
                return _c(
                  "div",
                  { key: error.message, staticClass: "mb-2" },
                  [
                    _c(
                      "vs-alert",
                      { attrs: { color: "danger", icon: "new_releases" } },
                      [_c("span", [_vm._v(_vm._s(error))])]
                    )
                  ],
                  1
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "vx-row d-flex align-items-stretch" }, [
            _vm.showWallet
              ? _c(
                  "div",
                  { staticClass: "vx-col w-full lg:w-1/3 mb-3" },
                  [
                    _c(
                      "vs-button",
                      _vm._b(
                        {
                          on: {
                            click: function($event) {
                              return _vm.onClickChangePaymentMethod(
                                _vm.paymentMethodEnum.WALLET
                              )
                            }
                          }
                        },
                        "vs-button",
                        _vm.paymentMethodButtonProp(
                          _vm.paymentMethodEnum.WALLET
                        ),
                        false
                      ),
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("account_balance_wallet")
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "small",
                          { staticClass: "font-bold text-uppercase" },
                          [_vm._v(_vm._s(_vm.$t("attribute.wallet")))]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showCreditCard
              ? _c(
                  "div",
                  { staticClass: "vx-col w-full lg:w-1/3 mb-3" },
                  [
                    _c(
                      "vs-button",
                      _vm._b(
                        {
                          on: {
                            click: function($event) {
                              return _vm.onClickChangePaymentMethod(
                                _vm.paymentMethodEnum.CREDIT_CARD
                              )
                            }
                          }
                        },
                        "vs-button",
                        _vm.paymentMethodButtonProp(
                          _vm.paymentMethodEnum.CREDIT_CARD
                        ),
                        false
                      ),
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("credit_card")
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "small",
                          { staticClass: "font-bold text-uppercase" },
                          [_vm._v(_vm._s(_vm.$t("attribute.creditCard")))]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showCreditCard &&
            _vm.paymentDetails[_vm.paymentMethodEnum.CREDIT_CARD].cards.length >
              0
              ? _c(
                  "div",
                  { staticClass: "vx-col w-full lg:w-1/3 mb-3" },
                  [
                    _c(
                      "vs-button",
                      _vm._b(
                        {
                          on: {
                            click: function($event) {
                              return _vm.onClickChangePaymentMethod(
                                _vm.paymentMethodEnum.SAVED_CC
                              )
                            }
                          }
                        },
                        "vs-button",
                        _vm.paymentMethodButtonProp(
                          _vm.paymentMethodEnum.SAVED_CC
                        ),
                        false
                      ),
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("credit_card")
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "small",
                          { staticClass: "font-bold text-uppercase" },
                          [_vm._v(_vm._s(_vm.$t("attribute.savedCC")))]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showPayNow
              ? _c(
                  "div",
                  { staticClass: "vx-col w-full lg:w-1/3 mb-3" },
                  [
                    _c(
                      "vs-button",
                      _vm._b(
                        {
                          on: {
                            click: function($event) {
                              return _vm.onClickChangePaymentMethod(
                                _vm.paymentMethodEnum.PAYNOW
                              )
                            }
                          }
                        },
                        "vs-button",
                        _vm.paymentMethodButtonProp(
                          _vm.paymentMethodEnum.PAYNOW
                        ),
                        false
                      ),
                      [
                        _c("img", {
                          staticStyle: { width: "100%" },
                          attrs: { src: "/images/logo/paynow-logo.png" }
                        })
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.paymentDetails[_vm.paymentMethodEnum.POST_PAID] &&
            _vm.showPostPaid
              ? _c(
                  "div",
                  { staticClass: "vx-col w-full lg:w-1/3 mb-3" },
                  [
                    _vm.paymentDetails[_vm.paymentMethodEnum.POST_PAID]
                      .is_post_paid
                      ? _c(
                          "vs-button",
                          _vm._b(
                            {
                              on: {
                                click: function($event) {
                                  return _vm.onClickChangePaymentMethod(
                                    _vm.paymentMethodEnum.POST_PAID
                                  )
                                }
                              }
                            },
                            "vs-button",
                            _vm.paymentMethodButtonProp(
                              _vm.paymentMethodEnum.POST_PAID
                            ),
                            false
                          ),
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("card_membership")
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "small",
                              { staticClass: "font-bold text-uppercase" },
                              [_vm._v(_vm._s(_vm.$t("attribute.postPaid")))]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showBankTransfer
              ? _c(
                  "div",
                  { staticClass: "vx-col w-full lg:w-1/3 mb-3" },
                  [
                    _c(
                      "vs-button",
                      _vm._b(
                        {
                          on: {
                            click: function($event) {
                              return _vm.onClickChangePaymentMethod(
                                _vm.paymentMethodEnum.BANK_TRANSFER
                              )
                            }
                          }
                        },
                        "vs-button",
                        _vm.paymentMethodButtonProp(
                          _vm.paymentMethodEnum.BANK_TRANSFER
                        ),
                        false
                      ),
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("account_balance")
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "small",
                          { staticClass: "font-bold text-uppercase" },
                          [_vm._v(_vm._s(_vm.$t("attribute.bankTransfer")))]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("vs-divider"),
          _vm._v(" "),
          _vm.paymentMethod == _vm.paymentMethodEnum.WALLET
            ? _c(
                "div",
                { staticClass: "vx-row w-full" },
                [
                  _vm._l(
                    _vm.paymentDetails[_vm.paymentMethodEnum.WALLET],
                    function(wallet, index) {
                      return [
                        wallet.currency.code ==
                        _vm.$store.getters.getUserCountry.currency.code
                          ? _c(
                              "div",
                              {
                                key: "wallet_" + index,
                                staticClass: "vx-col w-full lg:w-1/2"
                              },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    key:
                                      "WALLET_" +
                                      index +
                                      "_" +
                                      _vm.selectedWallet.id,
                                    staticClass: "w-full p-3 m-1",
                                    attrs: {
                                      color: _vm.renderWalletButtonColor(
                                        wallet
                                      ),
                                      type: _vm.renderWalletButtonType(wallet),
                                      disabled:
                                        _vm.checkIfDisabledWallet(wallet) ||
                                        _vm.loadingBtnCheckout
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.onClickChangeWallet(wallet),
                                          _vm.checkWalletBalanceAmount(wallet)
                                      }
                                    }
                                  },
                                  [
                                    _c("p", { staticClass: "font-bold" }, [
                                      _vm._v(
                                        _vm._s(wallet.currency.symbol) +
                                          " " +
                                          _vm._s(wallet.amount)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(wallet.currency.code) +
                                          " " +
                                          _vm._s(wallet.currency.name)
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    }
                  )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.paymentMethod == _vm.paymentMethodEnum.SAVED_CC &&
          _vm.showCreditCard
            ? _c(
                "div",
                { staticClass: "vx-row w-full" },
                _vm._l(
                  _vm.paymentDetails[_vm.paymentMethodEnum.CREDIT_CARD].cards,
                  function(saved_cc, index) {
                    return _c(
                      "div",
                      {
                        key: "credit_card_" + index,
                        staticClass: "vx-col w-full lg:w-1/2"
                      },
                      [
                        _c(
                          "vs-button",
                          {
                            key:
                              "CREDIT_CARD_" +
                              index +
                              "_" +
                              _vm.selectedCreditCard.id,
                            staticClass: "w-full p-3 m-1",
                            attrs: {
                              color: _vm.renderSavedCCButtonColor(saved_cc),
                              type: _vm.renderSavedCCButtonType(saved_cc),
                              disabled: _vm.loadingBtnCheckout
                            },
                            on: {
                              click: function($event) {
                                return _vm.onClickChangeSavedCC(saved_cc)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flex justify-between flex-wrap" },
                              [
                                _c("div", { staticClass: "font-bold" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        saved_cc.brand
                                          ? saved_cc.brand.toUpperCase()
                                          : "no_brand"
                                      ) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      saved_cc.exp_month
                                        ? saved_cc.exp_month + " / "
                                        : ""
                                    ) + _vm._s(saved_cc.exp_year)
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("small", [
                              _vm._v(
                                _vm._s(
                                  saved_cc.last4
                                    ? "**** **** **** " + saved_cc.last4
                                    : ""
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  }
                ),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.paymentMethod == _vm.paymentMethodEnum.SAVED_CC &&
          _vm.showCreditCard &&
          _vm.paymentDetails[_vm.paymentMethodEnum.CREDIT_CARD].cards.length > 0
            ? _c("vs-divider")
            : _vm._e(),
          _vm._v(" "),
          _vm.paymentMethod == _vm.paymentMethodEnum.CREDIT_CARD &&
          _vm.showCreditCard
            ? _c("div", { staticClass: "small mb-2" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("paymentMethod.orInputCardNumber")) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.paymentMethod == _vm.paymentMethodEnum.CREDIT_CARD &&
          _vm.showCreditCard
            ? _c("stripe-component", {
                staticClass: "mb-3",
                attrs: { defaultcc: _vm.selectedCreditCard.id },
                on: {
                  update: function($event) {
                    _vm.selectedCreditCard = { id: 0 }
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.paymentMethod == _vm.paymentMethodEnum.PAYNOW && _vm.showPayNow
            ? _c(
                "div",
                { staticClass: "small mb-2" },
                [
                  _c("input-image", {
                    attrs: {
                      title: _vm.$t("action.uploadProof"),
                      desc: _vm.$t("paymentMethod.uploadProofInstr")
                    },
                    on: {
                      onRemoveImage: function($event) {
                        _vm.imageProof = null
                      },
                      onUploadImage: function(file) {
                        return (_vm.imageProof = file)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.imageProof,
                        expression: "imageProof"
                      }
                    ],
                    attrs: { type: "hidden", name: "Upload Proof" },
                    domProps: { value: _vm.imageProof },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.imageProof = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("topup.Upload Proof"),
                          expression: "errors.has(`topup.Upload Proof`)"
                        }
                      ],
                      staticClass: "text-danger mt-2 text-sm"
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("paymentMethod.proofOfTransferRequired")
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "w-full mb-3" }, [
                    _c("img", {
                      staticStyle: {
                        width: "70%",
                        "margin-left": "auto",
                        "margin-right": "auto"
                      },
                      attrs: { src: _vm.payNowImage }
                    })
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.paymentMethod == _vm.paymentMethodEnum.BANK_TRANSFER &&
          _vm.showBankTransfer
            ? _c(
                "div",
                { staticClass: "small mb-2" },
                [
                  _c("input-image", {
                    attrs: {
                      title: _vm.$t("action.uploadProof"),
                      desc: _vm.$t("paymentMethod.uploadProofInstr")
                    },
                    on: {
                      onRemoveImage: function($event) {
                        _vm.imageProof = null
                      },
                      onUploadImage: function(file) {
                        return (_vm.imageProof = file)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.imageProof,
                        expression: "imageProof"
                      }
                    ],
                    attrs: { type: "hidden", name: "Upload Proof" },
                    domProps: { value: _vm.imageProof },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.imageProof = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("topup.Upload Proof"),
                          expression: "errors.has(`topup.Upload Proof`)"
                        }
                      ],
                      staticClass: "text-danger mt-2 text-sm"
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("paymentMethod.proofOfTransferRequired")
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "w-full mb-3" }, [
                    _c("img", {
                      staticStyle: {
                        width: "70%",
                        "margin-left": "auto",
                        "margin-right": "auto"
                      },
                      attrs: { src: _vm.bankTransferImage }
                    })
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showCheckoutButton
            ? _c(
                "vs-button",
                {
                  staticClass: "w-full p-3 m-1 font-bold",
                  attrs: {
                    type: "gradient",
                    color: "primary",
                    disabled: _vm.loadingBtnCheckout
                  },
                  on: {
                    click: function($event) {
                      return _vm.processPayment()
                    }
                  }
                },
                [
                  _c("span", { staticClass: "text-uppercase" }, [
                    _vm._v("CHECKOUT")
                  ])
                ]
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("vs-popup", {
        attrs: {
          title: _vm.$t("attribute.walletTopUp").toUpperCase(),
          active: _vm.topUpInsufficientAmountDialog
        },
        on: {
          "update:active": function($event) {
            _vm.topUpInsufficientAmountDialog = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }